import { useEffect, useState } from "react";
import { useAuthContext } from "../context/authContext";
import ResponsiveMenu, { ResponsiveMenuItem } from "./responsiveMenu";
import { isAdmin, isTeacher } from "../helpers/role";
import { ChatService } from "../APIService/ChatService";

function AppMenu() {
  if (window.location.pathname.startsWith("/print")) {
    return <></>; // Hide menu on print pages
  }
  const { isAuth, authInfo, studentId } = useAuthContext();
  const auth = localStorage.getItem("auth") || "{}";
  const lsAuthInfo = JSON.parse(auth);
  const [unreadChats, setUnreadChats] = useState(false);

  useEffect(() => {
    if (auth && !isNaN(Number(JSON.parse(auth).id))) {
      ChatService.getUnreadChats(Number(JSON.parse(auth).id)).then((data) => {
        setUnreadChats(data.length > 0);
      });
    }
  }, [isAuth]);

  const mainMenuBuilder = [
    { menuitem: "Главная", link: "/", condition: () => true },
    { menuitem: "Экзамены", link: "/exam", condition: () => true },
    { menuitem: "Олимпиады", link: "/theme", condition: () => true },
    {
      menuitem: "Обучение",
      link: "/learning",
      condition: () => isAuth,
    },
    {
      menuitem: "Отчеты",
      condition: () =>
        !isAuth ||
        (isAuth && (!isTeacher(authInfo.role) || isAdmin(authInfo.role))),
      submenu: [
        { menuitem: "Ответы (20)", link: "/answers", condition: () => true },
        {
          menuitem: "Домашние задания (25)",
          link: `/homework/${studentId}`,
          condition: () => isAuth,
        },
        {
          menuitem: "Сводка по ДЗ (83)",
          link: `/report83/${studentId}`,
          condition: () => isAuth,
        },
      ],
    },
    {
      menuitem: "Учительская",
      link: "/lk-for-teacher",
      condition: () =>
        isAuth && (isAdmin(authInfo.role) || isTeacher(authInfo.role)),
    },
  ];

  const mainMenu: ResponsiveMenuItem[] = [];
  mainMenuBuilder.forEach((item) => {
    if (item.condition() && item.link) {
      mainMenu.push({ menuitem: item.menuitem, link: item.link });
    } else if (item.condition() && item.submenu) {
      const submenu = item.submenu.filter((subitem) => subitem.condition());
      if (submenu.length > 0) {
        mainMenu.push({ menuitem: item.menuitem, submenu: submenu });
      }
    }
  });

  const rightMenuBuilder = [
    {
      menuitem: "Личный кабинет",
      link: "/lk",
      condition: () => lsAuthInfo && !isNaN(Number(lsAuthInfo.id)),
    },
    {
      menuitem: "Мой профиль",
      link: "/account",
      condition: () => lsAuthInfo && !isNaN(Number(lsAuthInfo.id)),
    },
    {
      menuitem: "Кошелёк",
      link: "/pay",
      condition: () => lsAuthInfo && !isNaN(Number(lsAuthInfo.id)),
    },
    {
      menuitem: "Выйти",
      link: "/logout",
      condition: () => lsAuthInfo && !isNaN(Number(lsAuthInfo.id)),
    },
  ];

  const rightMenu: ResponsiveMenuItem = {
    menuitem:
      lsAuthInfo && !isNaN(Number(lsAuthInfo.id))
        ? `ID_${lsAuthInfo.id}`
        : "Войти",
    data: unreadChats ? "notification" : "",
  };

  const rightMenuItems = rightMenuBuilder.filter((item) => item.condition());
  if (rightMenuItems.length > 0) {
    rightMenu.submenu = rightMenuItems.map((item) => ({
      menuitem: item.menuitem,
      link: item.link,
    }));
  } else {
    rightMenu.link = "/login";
  }

  return <ResponsiveMenu mainMenu={mainMenu} rightMenu={rightMenu} />;
}

export default AppMenu;
